import { DrawCabinetInsideElement } from './DrawCabinetInsideElement';

export class DrawInsideHookBar extends DrawCabinetInsideElement {
    Number!: number;
}
